<template>
  <section>
    <ul :class="[boxClass,hMode?hWidthClass:vWidthClass]">
      <li :class="[saveImgBtn]">
        <div class="tool_bar_menu" ref="saveImgBtn" title="保存图片" @click="saveImg"></div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,initPointBtn]">
        <div class="tool_bar_menu" ref="initPoint" title="初始视角" @click="initPoint"></div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,selectPointBtn]">
        <div class="tool_bar_menu" ref="selectPoint" title="选择视角" @click="selectPoint"></div>
        <div class="extend_icon"></div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" v-if="showSelectPointView">
          <li :class="[frontPoint]">
            <div class="tool_bar_menu" ref="frontPoint" title="前视角" @click="viewPort(1)"></div>
          </li>
          <li :class="[vSpaceClass,backPoint]">
            <div class="tool_bar_menu" ref="backPoint" title="后视角" @click="viewPort(2)"></div>
          </li>
          <li :class="[vSpaceClass,leftPoint]">
            <div class="tool_bar_menu" ref="leftPoint" title="左视角" @click="viewPort(4)"></div>
          </li>
          <li :class="[vSpaceClass,rightPoint]">
            <div class="tool_bar_menu" ref="rightPoint" title="右视角" @click="viewPort(3)"></div>
          </li>
          <li :class="[vSpaceClass,topPoint]">
            <div class="tool_bar_menu" ref="topPoint" title="上视角" @click="viewPort(6)"></div>
          </li>
          <li :class="[vSpaceClass,bottomPoint]">
            <div class="tool_bar_menu" ref="bottomPoint" title="下视角" @click="viewPort(5)"></div>
          </li>
        </ul>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,previewMode]" ref="modeBtn">
        <div class="tool_bar_menu" ref="changeMode" title="模式切换" @click="showMode"></div>
        <div class="extend_icon"></div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" v-if="showModeView">
          <li :class="[previewMode]">
            <div class="tool_bar_menu" title="预览模式" @click="doManageMode(0)"></div>
          </li>
          <li :class="[vSpaceClass,setCenterPort]">
            <div class="tool_bar_menu" title="设置中心点" @click="doManageMode(1)"></div>
          </li>
          <li :class="[vSpaceClass,manageMode]">
            <div class="tool_bar_menu" title="管理模式" @click="doManageMode(2)"></div>
          </li>
        </ul>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,showModel]">
        <div class="tool_bar_menu" ref="setModel" title="模型设置" @click="setModel"></div>
        <div class="extend_icon"></div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" v-if="showModelListView">
          <li :class="[showModel]">
            <div class="tool_bar_menu" title="显示模型" @click="doShowModel(0)"></div>
          </li>
          <li :class="[vSpaceClass,hidModel]">
            <div class="tool_bar_menu" title="隐藏模型" @click="doShowModel(1)"></div>
          </li>
          <li :class="[vSpaceClass,phModel]">
            <div class="tool_bar_menu" title="模型半透明" @click="doShowModel(2)"></div>
          </li>
          <li :class="[vSpaceClass,rePhModel]">
            <div class="tool_bar_menu" title="模型半透明恢复" @click="doShowModel(3)"></div>
          </li>
        </ul>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,showGJBtn]">
        <div class="tool_bar_menu" ref="setGJ" title="构建设置" @click="setGJ"></div>
        <div class="extend_icon"></div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" v-if="showGJListView">
          <li :class="[showGJ]">
            <div class="tool_bar_menu" title="显示构建" @click="doShowGJ(0)"></div>
          </li>
          <li :class="[vSpaceClass,hidGJ]">
            <div class="tool_bar_menu" title="隐藏构建" @click="doShowGJ(1)"></div>
          </li>
          <li :class="[vSpaceClass,phGJ]">
            <div class="tool_bar_menu" title="构建半透明" @click="doShowGJ(2)"></div>
          </li>
          <li :class="[vSpaceClass,rePhGJ]">
            <div class="tool_bar_menu" title="构建半透明恢复" @click="doShowGJ(3)"></div>
          </li>
        </ul>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,lineModeBtn]">
        <div class="tool_bar_menu" ref="lineMode" title="线框模式" @click="doLineMode"></div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,partShowBtn]">
        <div class="tool_bar_menu" ref="partShow" title="局部显示" @click="doPartShow"></div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,sectionBtn]">
        <div class="tool_bar_menu" ref="section" title="剖切" @click="showSection"></div>
        <div :class="[menuDialog,hMode?hMenuDialog:vMenuDialog]" v-if="sectionStatus">
          <div class="dialog_title">剖切</div>
          <div class="dialog_c">
            <div class="dialog_b_slider_box">
              <span class="dialog_b_slider_label">X</span>
              <el-slider v-model="sectionX" class="dialog_b_slider" range @input="doSectionX" :min="0"
                         :max="100"></el-slider>
            </div>
            <div class="dialog_b_slider_box">
              <span class="dialog_b_slider_label">Y</span>
              <el-slider v-model="sectionY" class="dialog_b_slider" range @input="doSectionY" :min="0"
                         :max="100"></el-slider>
            </div>
            <div class="dialog_b_slider_box">
              <span class="dialog_b_slider_label">Z</span>
              <el-slider v-model="sectionZ" class="dialog_b_slider" range @input="doSectionZ" :min="0"
                         :max="100"></el-slider>
            </div>
          </div>
        </div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,blastBtn]">
        <div class="tool_bar_menu" ref="blast" title="爆炸" @click="showBlast"></div>
        <div :class="[menuDialog,hMode?hMenuDialog:vMenuDialog]" v-if="blastStatus">
          <div class="dialog_title">爆炸</div>
          <div class="dialog_c">
            <el-slider v-model="blastV" class="dialog_slider" @input="doBlast" :min="0" :max="100"></el-slider>
          </div>
        </div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,measureBtn]" ref="measureBtn">
        <div class="tool_bar_menu" ref="measure" title="测量" @click="setMeasure"></div>
        <div class="extend_icon"></div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" v-if="showMeasureView">
          <li :class="[measureDistance]">
            <div class="tool_bar_menu" title="距离测量" @click="doMeasure(4)"></div>
          </li>
          <li :class="[vSpaceClass,measureAngle]">
            <div class="tool_bar_menu" title="角度测量" @click="doMeasure(5)"></div>
          </li>
          <li :class="[vSpaceClass,measureArea]">
            <div class="tool_bar_menu" title="平面面积测量" @click="doMeasure(6)"></div>
          </li>
          <li :class="[vSpaceClass,measureSurfaceArea]">
            <div class="tool_bar_menu" title="表面积测量" @click="doMeasure(7)"></div>
          </li>
          <li :class="[vSpaceClass,measureVolume]">
            <div class="tool_bar_menu" title="体积测量" @click="doMeasure(8)"></div>
          </li>
          <li :class="[vSpaceClass,measureWeight]">
            <div class="tool_bar_menu" title="重量测量" @click="doMeasure(9)"></div>
          </li>
        </ul>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,propertyBtn]">
        <div class="tool_bar_menu" ref="property" title="属性" @click="doPropertyShow"></div>
        <div :class="[menuDialog,hMode?hMenuDialog:vPropertyClass]" id="propertyView">
          <div class="property_title">基本信息</div>
          <div class="property_c">
            <el-tabs type="border-card" @tab-click="changeTabs">
              <el-tab-pane label="属性" class="p_pane">
                <div id="p_list"></div>
              </el-tab-pane>
              <el-tab-pane label="材质" class="p_pane">
                <div id="c_list"></div>
              </el-tab-pane>
              <el-tab-pane label="特性" class="p_pane">
                <div id="t_list"></div>
              </el-tab-pane>
              <el-tab-pane label="类型" class="p_pane">
                <div id="l_list"></div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </li>
      <li :class="[hMode?hSpaceClass:vSpaceClass,roamBtn]">
        <div class="tool_bar_menu" ref="roamBtn" title="漫游设置" @click="doRoamBtnShow">
          <div class="extend_icon"></div>
        </div>
        <ul :class="[menuListBox,hMode?hMenuList:vMenuList]" id="roamView">
          <li :class="[setRoam]">
            <div class="tool_bar_menu" title="录制漫游" @click="doSetRoamView"></div>
            <div :class="[menuDialog,hMode?hMenuDialog:vRoamClass]" id="setRoamView">
              <div class="property_title">录制漫游</div>
              <div class="roam_c">
                <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
                  <el-form-item label="漫游名称" prop="roamName">
                    <el-input v-model="formObj.roamName" placeholder="请输入名称" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="播放时长(秒)" prop="roamTime">
                    <el-input-number v-model="formObj.roamTime" controls-position="right" :min="1"></el-input-number>
                  </el-form-item>
                </el-form>

                <div class="roamList" v-for="(item,index) in roamPointList" :key="index">漫游点{{index+1}}<i
                  class="el-icon-delete delRoam" @click="delRoamPoint(item)"></i></div>
                <div class="roamDoBtn">
                  <el-button @click.native="addRoamPoint" type="warning" size="small">添加漫游点</el-button>
                  <el-button type="success" @click.native="previewRoam" size="small">预演漫游</el-button>
                  <el-button type="primary" @click.native="doSubmit" size="small">录制</el-button>
                </div>
              </div>
            </div>
          </li>
          <li :class="[vSpaceClass,roamWay]">
            <div class="tool_bar_menu" title="漫游播放" @click="doRoamWayView"></div>
            <div :class="[menuDialog,hMode?hMenuDialog:vRoamClass]" id="roamWayView">
              <div class="property_title">漫游播放</div>
              <div class="roam_c">
                <div class="roamList" v-for="(item,index) in roamWayList" :key="index">{{item.roamName}}
                  <i class="el-icon-delete delRoam" @click="delDBRoamPoint(item)"></i>
                  <i class="el-icon-video-pause delRoam" @click="pauseRoam(item)"></i>
                  <i class="el-icon-video-play delRoam" @click="playRoam(item)"></i>

                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>

      <div style="clear: both"></div>
    </ul>
  </section>
</template>

<script>
  import {setRoam, roamList,delRoam} from '../../api/api'

  export default {
    name: "ModelToolBar",
    props: {
      mode: '',
      tokenId: null,
    },
    data() {
      return {
        formObj: {roamTime: 1},
        formRules: {
          roamName: [
            {required: true, message: '请输入漫游名称', trigger: 'blur'}
          ],
          roamTime: [
            {required: true, message: '请输入播放时长', trigger: 'blur'}
          ],
        },
        roamPointList: [],
        roamWayList:[],
        roamPlay:false,
        //=====================
        hMode: true,
        hSpaceClass: 'h_space_line',
        vSpaceClass: 'v_space_line',
        vWidthClass: 'v_width',
        hWidthClass: 'h_width',
        boxClass: 'toolbar_box',
        hMenuList: 'tool_bar_menu_list_h',
        vMenuList: 'tool_bar_menu_list_v',
        menuListBox: 'tool_bar_menu_list',
        menuDialog: 'tool_bar_menu_dialog',
        hMenuDialog: 'tool_bar_menu_dialog_h',
        vMenuDialog: 'tool_bar_menu_dialog_v',
        vPropertyClass: 'v_property',
        vRoamClass: 'v_roam',
        //================================
        saveImgBtn: 'save_img_btn',//保存图片

        initPointBtn: 'init_point_btn',//初始视角

        selectPointBtn: 'select_point_btn',//选择视角
        frontPoint: 'front_point',//前视角
        backPoint: 'back_point',//后视角
        leftPoint: 'left_point',//左视角
        rightPoint: 'right_point',//右视角
        topPoint: 'top_point',//上视角
        bottomPoint: 'bottom_point',//下视角

        previewMode: 'preview_mode',//预览模式
        setCenterPort: 'set_center_port',//设置中心点
        manageMode: 'manage_mode',//管理模式

        showModel: 'show_model',//显示模型
        hidModel: 'hid_model',//隐藏模型
        phModel: 'ph_model',//模型半透明
        rePhModel: 're_ph_mode',//恢复模型透明度

        showGJBtn: 'show_gj_btn',//构建设置
        showGJ: 'show_gj',//显示构建
        hidGJ: 'hid_gj',//隐藏构建
        phGJ: 'ph_gj',//构建半透明
        rePhGJ: 're_ph_gj',//恢复构建透明度
        lineModeBtn: 'line_mode',//线框模式
        partShowBtn: 'part_show_btn',//局部显示
        sectionBtn: 'section_btn',//剖切
        blastBtn: 'blast_btn',//爆炸
        measureBtn: 'measure_btn',//测量
        measureDistance: 'measure_distance',//距离测量
        measureAngle: 'measure_angle',//角度测量
        measureArea: 'measure_area',//平面面积测量
        measureSurfaceArea: 'measure_surface_area',//表面积测量
        measureVolume: 'measure_volume',//体积测量
        measureWeight: 'measure_weight',//重量测量
        propertyBtn: 'property_btn',//属性
        roamBtn: 'roam_btn',//漫游
        setRoam: 'set_roam',//录制漫游
        roamWay: 'roam_way',//漫游轨迹
        //==========================================
        showSelectPointView: false,//视点工具下拉视图
        showModeView: false,//模式工具下拉视图
        showModelListView: false,//模型显示工具下拉视图
        showGJListView: false,//构建显示工具下拉视图
        showMeasureView: false,//测量视图
        lineStatus: false,//线框状态
        partShowStatus: false,//局部显示
        sectionStatus: false,//剖切显示
        blastStatus: false,//爆炸显示
        propertyStatus: false,//属性显示
        roamStatus: false,//漫游显示
        setRoamStatus: false,//录制漫游视图
        roamWayStatus: false,//漫游轨迹视图
        //============================================
        sectionX: [0, 100],
        sectionY: [0, 100],
        sectionZ: [0, 100],
        blastV: 0,
      };
    },
    methods: {
      //删除列表漫游
      delDBRoamPoint:function(obj){
        this.$confirm('确认删除录制吗？', '提示', {type: 'warning'}).then(() => {
          delRoam({id:obj.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.$message({
                message: "删除成功",
                type: 'success'
              });
              this.doRoamWayView();
            }
          });
        })
      },
      //播放漫游
      playRoam:function(obj){
        let cs  = obj.coordinates.split("#");
        if(!this.roamPlay){
          FlyAnimation(cs, obj.roamTime * 1000);
        }else{
          FlyResume();
          this.roamPlay = false;
        }

      },
      //暂停漫游
      pauseRoam:function(obj){
        FlyPause();
        this.roamPlay=true;
      },
      //漫游轨迹视图
      doRoamWayView:function(){
        this.clearActive(11)
        if (!this.roamWayStatus) {
          this.roamWayStatus = true;
          roamList({id:this.tokenId}, this.GLOBAL.header).then(result => {
            if(result.success){
              this.roamWayList = result.data;
            }
          });
          $("#roamWayView").show();
        } else {
          this.roamWayStatus = false;
          $("#roamWayView").hide();
        }
      },
      //预演漫游
      previewRoam: function () {
        FlyAnimation(this.roamPointList, this.formObj.roamTime * 1000);
      },
      //录制
      doSubmit: function () {
        if(this.roamPointList.length<=0){
          this.$message({
            message: "请添加漫游点",
            type: 'error'
          });
          return false;
        }
        this.formObj.coordinates = this.roamPointList.join('#');
        this.formObj.projectId = this.tokenId;
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认录制吗？', '提示', {type: 'warning'}).then(() => {
              setRoam(this.formObj, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.$message({
                    message: "录制成功",
                    type: 'success'
                  });
                }
              });
            })
          }
        });
      },
      //添加漫游点
      addRoamPoint: function () {
        let gamera = GetCamera()
        this.roamPointList.push(gamera);
      },
      //删除漫游点
      delRoamPoint: function (p) {
        let index = this.roamPointList.indexOf(p);
        this.roamPointList.splice(index, 1);
      },
      //漫游
      doRoamBtnShow: function () {
        this.clearActive(9)
        this.$refs.roamBtn.classList.add('menu_active');
        if (!this.roamStatus) {
          this.roamStatus = true;
          $("#roamView").show();
        } else {
          this.roamStatus = false;
          $("#roamView").hide();
        }
      },
      //漫游设置视图
      doSetRoamView: function () {
        this.clearActive(10)
        if (!this.setRoamStatus) {
          this.setRoamStatus = true;
          $("#setRoamView").show();
        } else {
          this.setRoamStatus = false;
          $("#setRoamView").hide();
        }
      },
      //保存图片
      saveImg: function () {
        this.clearActive();
        this.$refs.saveImgBtn.classList.add('menu_active')
        SaveImage();
      },
      //初始视角
      initPoint: function () {
        this.clearActive();
        this.$refs.initPoint.classList.add('menu_active');
        ZoomFitAll();
      },
      //选择视角
      selectPoint: function () {
        this.clearActive(1);
        this.$refs.selectPoint.classList.add('menu_active');
        if (this.showSelectPointView) {
          this.showSelectPointView = false;
        } else {
          this.showSelectPointView = true;
        }

      },
      //视角
      viewPort: function (p) {
        switch (p) {
          case 1:
            SetViewPort('front');
            break;
          case 2:
            SetViewPort('back');
            break;
          case 3:
            SetViewPort('right');
            break;
          case 4:
            SetViewPort('left');
            break;
          case 5:
            SetViewPort('bottom');
            break;
          case 6:
            SetViewPort('top');
            break;
        }

      },
      //模式切换
      showMode: function () {
        this.clearActive(2);
        this.$refs.changeMode.classList.add('menu_active');
        if (this.showModeView) {
          this.showModeView = false;
        } else {
          this.showModeView = true;
        }
      },
      //测量
      setMeasure: function () {
        this.clearActive(7);
        this.$refs.measure.classList.add('menu_active');
        if (this.showMeasureView) {
          this.showMeasureView = false;
        } else {
          this.showMeasureView = true;
        }
      },
      doMeasure: function (p) {
        SetClickMode(p)
        clickMode = p;
        this.showMeasureView = false;
        this.clearModeBtnStyle();
        if (p == 4) {
          this.$refs.measureBtn.classList.add('measure_distance');
        }
        if (p == 5) {
          this.$refs.measureBtn.classList.add('measure_angle');
        }
        if (p == 6) {
          this.$refs.measureBtn.classList.add('measure_area');
        }
        if (p == 7) {
          this.$refs.measureBtn.classList.add('measure_surface_area');
        }
        if (p == 8) {
          this.$refs.measureBtn.classList.add('measure_volume');
        }
        if (p == 9) {
          this.$refs.measureBtn.classList.add('measure_weight');
        }
      },
      //模式管理
      doManageMode: function (p) {
        SetClickMode(p)
        clickMode = p;
        this.showModeView = false;
        this.clearModeBtnStyle();
        if (p == 0) {
          this.$refs.modeBtn.classList.add('preview_mode');
          this.clearActors();
        }
        if (p == 1) {
          this.$refs.modeBtn.classList.add('set_center_port');
          this.clearActors();
        }
        if (p == 2) {
          this.$refs.modeBtn.classList.add('manage_mode');
          searchProperty = true;
        }
      },
      //打开模型设置工具列表
      setModel: function () {
        this.clearActive(3);
        this.$refs.setModel.classList.add('menu_active');
        if (this.showModelListView) {
          this.showModelListView = false;
        } else {
          this.showModelListView = true;
        }
      },
      //模型显示状态
      doShowModel: function (p) {
        switch (p) {
          case 0:
            SetModelVisible(this.tokenId, true)
            break;
          case 1:
            SetModelVisible(this.tokenId, false)
            break;
          case 2:
            SetModelAlpha(this.tokenId, 0.2)//模型半透明
            break;
          case 3:
            SetModelAlpha(this.tokenId, 1.0)//模型半透明恢复
            break;
        }
      },
      //打开构建设置工具列表
      setGJ: function () {
        this.clearActive(4);
        this.$refs.setGJ.classList.add('menu_active');
        if (this.showGJListView) {
          this.showGJListView = false;
        } else {
          this.showGJListView = true;
        }
      },
      //构建状态
      doShowGJ: function (p) {
        let len = hasSelectionIds.length;
        switch (p) {
          case 0:
            // for (var i = 0; i < len; i++) {
            //   SetActorVisible(hasSelectionIds[i], true)
            // }
            SetActorVisible(hasSelectionIds.join("#"), true);
            break;
          case 1:
            // for (var i = 0; i < len; i++) {
            //   SetActorVisible(hasSelectionIds[i], false)
            // }
            SetActorVisible(hasSelectionIds.join("#"), false);
            break;
          case 2:
            // for (var i = 0; i < len; i++) {
            //   SetActorAlpha(hasSelectionIds[i], 0.2)
            // }
            SetActorAlpha(hasSelectionIds.join("#"), 0.2);
            break;
          case 3:
            // for (var i = 0; i < len; i++) {
            //   SetActorAlpha(hasSelectionIds[i], 1)
            // }
            SetActorAlpha(hasSelectionIds.join("#"), 1);
            break;
        }
      },
      //线框模式
      doLineMode: function () {
        this.clearActive(-1);
        this.$refs.lineMode.classList.add('menu_active');
        if (!this.lineStatus) {
          SetModelWireFrame(this.tokenId);
          this.lineStatus = true;
        } else {
          SetModelNomal(this.tokenId);
          this.lineStatus = false;
        }
      },
      //局部显示
      doPartShow: function () {
        this.clearActive(-1);
        this.$refs.partShow.classList.add('menu_active');
        if (!this.partShowStatus) {
          if(hasSelectionIds.length>0){
            ShowActors(hasSelectionIds);
            this.partShowStatus = true;
          }
        } else {
          ResetAllActor();
          let r = parseInt(selObjectColor.substr(1, 2), 16);
          let g = parseInt(selObjectColor.substr(3, 2), 16);
          let b = parseInt(selObjectColor.substr(5, 2), 16);
          SetActorColor(hasSelectionIds.join("#"), r, g, b);

          // hasSelectionIds = [];
          this.partShowStatus = false;
        }
      },
      //剖切视图
      showSection: function () {
        this.clearActive(5)
        this.$refs.section.classList.add('menu_active');
        if (!this.sectionStatus) {
          this.sectionX = [0, 100];
          this.sectionY = [0, 100];
          this.sectionZ = [0, 100];
          this.sectionStatus = true;
        } else {
          this.sectionStatus = false;
        }
      },
      //剖切
      doSectionX: function (v) {
        let rangeFrom = 0;
        let rangeTo = 100;
        if ((v[0]) != rangeFrom) {
          PlateClip('x-min', (v[0]) / 100);
          rangeFrom = v[0];
        }
        if ((v[1]) != rangeTo) {
          PlateClip('x-max', (100 - v[1]) / 100);
          rangeTo = v[1];
        }
      },
      doSectionY: function (v) {
        let rangeFrom = 0;
        let rangeTo = 100;
        if ((v[0]) != rangeFrom) {
          PlateClip('y-min', (v[0]) / 100);
          rangeFrom = v[0];
        }
        if ((v[1]) != rangeTo) {
          PlateClip('y-max', (100 - v[1]) / 100);
          rangeTo = v[1];
        }
      },
      doSectionZ: function (v) {
        let rangeFrom = 0;
        let rangeTo = 100;
        if ((v[0]) != rangeFrom) {
          PlateClip('z-min', (v[0]) / 100);
          rangeFrom = v[0];
        }
        if ((v[1]) != rangeTo) {
          PlateClip('z-max', (100 - v[1]) / 100);
          rangeTo = v[1];
        }
      },
      //爆炸视图
      showBlast: function () {
        this.clearActive(6)
        this.$refs.blast.classList.add('menu_active');
        if (!this.blastStatus) {
          this.blastV = 0;
          this.blastStatus = true;
        } else {
          this.blastStatus = false;
        }
      },
      //爆炸
      doBlast: function (v) {
        PopOut(v / 100);
      },
      //属性
      doPropertyShow: function () {
        SetClickMode(2);
        clickMode = 2;
        searchProperty = true;
        this.clearActive(8)
        this.clearModeBtnStyle();
        this.$refs.property.classList.add('menu_active');
        this.$refs.modeBtn.classList.add('manage_mode');
        if (!this.propertyStatus) {
          this.propertyStatus = true;
          $("#propertyView").show();
        } else {
          this.propertyStatus = false;
          $("#propertyView").hide();
        }
      },
      //转换属性标签页
      changeTabs: function () {
      },
      //清除选中状态
      clearActive: function (p) {
        this.roamPointList = [];
        $(".tool_bar_menu").removeClass("menu_active");
        if (p != 1) {
          this.showSelectPointView = false;
        }
        if (p != 2) {
          this.showModeView = false;
        }
        if (p != 3) {
          this.showModelListView = false;
        }
        if (p != 4) {
          this.showGJListView = false;
        }
        if (p != 5) {
          this.sectionStatus = false;
        }
        if (p != 6) {
          this.blastStatus = false;
        }
        if (p != 7) {
          this.showMeasureView = false;
        }
        if (p != 8) {
          this.propertyStatus = false;
          searchProperty = false;
          $("#propertyView").hide();
        }
        if (p != 9 && p != 10 && p != 11) {
          this.roamStatus = false;
          $("#roamView").hide();
        }
        if (p != 10) {
          this.setRoamStatus = false;
          $("#setRoamView").hide();
        }
        if (p != 11) {
          this.roamWayStatus = false;
          $("#roamWayView").hide();
        }
        PopOut(0);
        ResetClip();
        FlyStop();
      },
      //清除模式选项按钮样式
      clearModeBtnStyle: function () {
        this.$refs.modeBtn.classList.remove('preview_mode');
        this.$refs.modeBtn.classList.remove('set_center_port');
        this.$refs.modeBtn.classList.remove('manage_mode');
        this.$refs.measure.classList.remove('measure_distance');
        this.clearMeasureBtnStyle();
        this.$refs.modeBtn.classList.add('preview_mode');
      },
      //清除测量选项按钮样式
      clearMeasureBtnStyle: function () {
        this.$refs.measureBtn.classList.remove('measure_distance');
        this.$refs.measureBtn.classList.remove('measure_angle');
        this.$refs.measureBtn.classList.remove('measure_area');
        this.$refs.measureBtn.classList.remove('measure_surface_area');
        this.$refs.measureBtn.classList.remove('measure_volume');
        this.$refs.measureBtn.classList.remove('measure_weight');
      },
      //恢复构建 选中状态
      clearActors: function () {
        for (let i = 0; i < hasSelectionIds.length; i++) {
          ResetActor(hasSelectionIds[i]);
        }
        hasSelectionIds = [];
      }

    },
    mounted() {
      //工具条默认水平方向 horizontal
      if (this.mode == 'vertical') {
        this.hMode = false;
      } else {
        this.hMode = true;
      }
      $("#roamWayView").hide();
      $("#setRoamView").hide();
      $("#roamView").hide();
      $("#propertyView").hide();
    },
    destroyed() {
      if(loadFinish){
        PopOut(0);
        ResetClip();
      }

    }
  }
</script>

<style scoped>
  .save_img_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12.png") no-repeat center center;
  }

  .init_point_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/14.png") no-repeat center center;
  }

  .select_point_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/13.png") no-repeat center center;
  }

  .front_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_1.png") no-repeat center center;
  }

  .back_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_2.png") no-repeat center center;
  }

  .left_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_4.png") no-repeat center center;
  }

  .right_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_3.png") no-repeat center center;
  }

  .top_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_6.png") no-repeat center center;
  }

  .bottom_point {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/12_5.png") no-repeat center center;
  }

  .change_mode {
    background: url("../../../static/bim/webimg/toolbar/manageMode.png") no-repeat center center;
  }

  .preview_mode {
    background: url("../../../static/bim/webimg/toolbar/viewmode.png") no-repeat center center;
  }

  .set_center_port {
    background: url("../../../static/bim/webimg/toolbar/movemode.png") no-repeat center center;
  }

  .manage_mode {
    background: url("../../../static/bim/webimg/toolbar/manageMode.png") no-repeat center center;
  }

  .show_model {
    background: url("../../../static/bim/webimg/toolbar/btnmodelshow.png") no-repeat center center;
  }

  .hid_model {
    background: url("../../../static/bim/webimg/toolbar/btnmodelhide.png") no-repeat center center;
  }

  .ph_model {
    background: url("../../../static/bim/webimg/toolbar/btnmodeltouming.png") no-repeat center center;
  }

  .re_ph_mode {
    background: url("../../../static/bim/webimg/toolbar/btnmodeltoumingreset.png") no-repeat center center;
  }

  .show_gj_btn {
    background: url("../../../static/bim/webimg/toolbar/goujian.png") no-repeat center center;
  }

  .show_gj {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/7_1.png") no-repeat center center;
  }

  .hid_gj {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/7_3.png") no-repeat center center;
  }

  .ph_gj {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/7_2.png") no-repeat center center;
  }

  .re_ph_gj {
    background: url("../../../static/bim/webimg/toolbar/goujian.png") no-repeat center center;
  }

  .line_mode {
    background: url("../../../static/bim/webimg/toolbar/line.png") no-repeat center center;
  }

  .part_show_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/allmode.png") no-repeat center center;
  }

  .section_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/8.png") no-repeat center center;
  }

  .blast_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/boom.png") no-repeat center center;
  }

  .measure_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/measure.png") no-repeat center center;
  }

  .measure_distance {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/2.png") no-repeat center center;
  }

  .measure_angle {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/5.png") no-repeat center center;
  }

  .measure_area {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/flatarea.png") no-repeat center center;
  }

  .measure_surface_area {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/surfacearea.png") no-repeat center center;
  }

  .measure_volume {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/volume.png") no-repeat center center;
  }

  .measure_weight {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/weight.png") no-repeat center center;
  }

  .property_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/20.png") no-repeat center center;
  }

  .roam_btn {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/roamrecords.png") no-repeat center center;
  }

  .set_roam {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/roamcopy.png") no-repeat center center;
  }

  .roam_way {
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/roamstart.png") no-repeat center center;
  }

  /*==============================*/
  .v_width {
    width: 40px;
  }

  .h_width {
    height: 40px;
  }

  .toolbar_box {
    margin: 0;
    padding: 0px;
    background: #f6f6f6;
    border-radius: 3px;
  }

  .toolbar_box li {
    position: relative;
    list-style: none;
    float: left;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  .tool_bar_menu {
    width: 40px;
    height: 40px;
  }

  .tool_bar_menu:hover {
    background: #c6e9ff;
    opacity: 0.3;
  }

  .h_space_line {
    border-left: 1px solid #dddddd
  }

  .v_space_line {
    border-top: 1px solid #dddddd
  }

  .menu_active {
    background: #c6e9ff;
    opacity: 0.5;
  }

  .extend_icon {
    position: absolute;
    right: 1px;
    top: 13px;
    width: 12px;
    height: 12px;
    background: url("../../../static/bim/webimg/toolbar/toolbar_icon/arrows_down.png") no-repeat center center;
  }

  .tool_bar_menu_list {
    margin: 0;
    padding: 0;
    width: 40px;
    position: absolute;
    background: #f6f6f6;
  }

  .tool_bar_menu_list li {
    list-style: none;
    width: 40px;
    height: 40px;
  }

  .tool_bar_menu_list_v {
    left: -42px;
    top: 0px;
  }

  .tool_bar_menu_list_h {
    top: 40px
  }

  .tool_bar_menu_dialog {
    margin: 0;
    padding: 0;
    position: absolute;
    background: #f6f6f6;
  }

  .tool_bar_menu_dialog_h {
    top: 40px;
    right: 0px;
    z-index: 9999;
  }

  .tool_bar_menu_dialog_v {
    right: 42px;
    top: 0px;
  }

  .dialog_title {
    width: 200px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 120, 214, 0.7);
    color: #fff;
    text-align: center;
  }

  .dialog_c {
    width: 200px;
    text-align: center;
  }

  .dialog_slider {
    width: 160px;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .dialog_b_slider {
    width: 140px;
    margin: auto;
    float: right;
    margin-right: 15px;
  }

  .dialog_b_slider_box {
    position: relative;
    width: 200px;
    height: 40px;
    line-height: 40px;
  }

  .dialog_b_slider_label {
    float: left;
    margin-left: 15px;
  }

  .property_title {
    width: 400px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 120, 214, 0.7);
    color: #fff;
    text-align: left;
    text-indent: 1em;
  }

  .property_c {
    width: 400px;
    text-align: center;
  }

  .p_pane {
    height: 600px;
    overflow-y: scroll;
    padding: 15px;
  }

  .p_pane::-webkit-scrollbar { /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }

  .p_pane::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .p_pane::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .v_property {
    right: 42px;
    bottom: -300px;
    z-index: 9999;
  }

  .v_roam {
    right: 42px;
    bottom: 0px;
    z-index: 9999;
  }

  .roam_c {
    width: 360px;
    margin: auto;
    margin-top: 20px;
  }

  .roamDoBtn {
    margin-bottom: 20px;
    margin-top: 10px;
    text-align: center;
  }

  .roamList {
    width: 360px;
    text-indent: 2em;
    height: 25px;
    line-height: 25px;
    position: relative;
    margin-bottom: 20px;
  }

  .delRoam {
    float: right;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/ModelToolBar.vue